import gsap from 'gsap';
import { html } from '@resn/gozer-core';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import AssetsMixin from 'utils/loading/assets-mixin';

import Copy from '@resn/gozer-core/copy';
import Svg from 'component/svg';
import { autobind } from 'core-decorators';
import { getRoute } from 'utils/get-pages';
import splitText from 'utils/gsap/split-text';

import BtnMain from 'component/btn-main';
import TextContentAnimation from 'component/text-content-animation';

import getStore from 'core/store';
const store = getStore();

import './index.scss';
import { navigate } from 'utils/router-utils';

const title = 'Oxelife';

// <h1 class="homeSoftware__textLine1  text-heading2">On-Demand Video</h1>
// <h1 class="homeSoftware__textLine2  text-heading2">Content, <span class="highlight">Anytime.</span></h1>
// <h1 class="homeSoftware__textLine1  text-heading2">${Copy.get('home-oxelife-quote-quote')}</h1>
const template = ({ options }) => html`
    <section class="homeSoftware__feature--3" align="left">
        <div class="homeSoftware__featureInner  grid  maxWidth">
            <div class="homeSoftware__divider"></div>
            <header class="homeSoftware__header">
                <h1 data-ui="title" class="homeSoftware__textLine1  text-heading2">
                    ${unsafeHTML(Copy.get('home-oxelife-quote-quote'))}
                </h1>
            </header>

            <div data-ui="imgWrap" class="homeSoftware__imgWrap"></div>

            <div data-ui="content" class="homeSoftware__content">
                <h3 data-ui="pretitle" class="homeSoftware__label  text-smallLabel">
                    ${Copy.get('home-module-6-pretitle')}
                </h3>
                <h1 data-ui="logo" class="homeSoftware__title">
                    ${title} ${Svg('oxelife-logo-inverse', 'homeSoftware__logo')}
                </h1>
                <h2 data-ui="subtitle" class="homeSoftware__subtitle  text-heading6">
                    ${Copy.get('home-module-6-subtitle')}
                </h2>
                <p data-ui="body" class="homeSoftware__body  text-body2">${Copy.get('home-module-6-paragraph')}</p>
            </div>
        </div>
    </section>
`;

@componentMixin(AssetsMixin())
@componentMixin(DomComponentMixin)
class HomeSoftwareFeature3 extends Component {
    props = {
        top: 0,
        bottom: 0,
        animateIntro: false,
    };

    options = {
        template,
    };

    assets = {
        img: 'static/images/pages/home/home-oxelife.png#imgo',
    };

    onAssetsPreloaderComplete() {
        const img = this.assets.img.cloneNode();
        img.classList.add('homeSoftware__img');

        this.ui.imgWrap.appendChild(img);
    }

    async onSetup() {
        this.btn = await new BtnMain().setup({
            options: {
                appendTo: this.ui.content,
                onClick: this.onExploreXP1Click,
            },
            props: {
                text: Copy.get('home-module-4-button'),
            },
        });

        this.animatedContent = await new TextContentAnimation().setup({
            options: {
                el: this.ui.content,
            },
            props: {
                active: () => this.props.active,
            },
        });

        // if (!('fonts' in document)) return;

        // document.fonts.ready.then(() => {
        // setTimeout(() => {
        // this.setupSplitText();
        // }, 5000);
        // });
    }

    setupSplitText() {
        const options = {
            root: null,
            rootMargin: '-25%',
            threshold: 0,
        };

        this.observer = new IntersectionObserver(this.onIntersectIntro, options);
        this.observer.observe(this.ui.title);

        const split = new splitText(this.ui.title, { type: 'lines', linesClass: 'splitText__lines' });

        this.introElements = [...split.lines];
        this.introElements.push();

        gsap.set(this.introElements, { alpha: 0, willChange: 'transform' });
    }

    @autobind
    onIntersectIntro(entries) {
        const entry = entries.find((entry) => entry.target === this.ui.title);

        if (entry) {
            if (this.props.animateIntro) return;
            this.props.animateIntro = entry.isIntersecting;
        }
    }

    onAnimateIntro() {
        const { mobile, scale } = store.state;

        const yFrom = (mobile ? 50 : 160) * scale;

        gsap.to(this.introElements, { alpha: 1, duration: 1, stagger: 0.1 });
        gsap.fromTo(this.introElements, { y: yFrom }, { y: 0, duration: 2.5, stagger: 0.1, ease: 'expo.out' });
        // });
    }

    offAnimateIntro() {
        gsap.set(this.introElements, { alpha: 0 });
    }

    @autobind
    onExploreXP1Click() {
        navigate(getRoute('oxelife'));
    }

    onBeforeDestroy() {
        // this.observer.unobserve(this.ui.title);
    }
}

export default HomeSoftwareFeature3;
